import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import {timeFormat} from 'd3-time-format'
import {withBoundary} from 'Components/ErrorBoundary'
import DocumentTitle from 'react-document-title'
import Header from './Header'
import Cards from './Cards'
import Transactions from './tables/Transactions'
import Positions from './tables/Positions'
import Charts from './Charts'

import style from './style.sass'

@withBoundary
@withRouter
@inject('store') @observer
class PaperTrading extends Component {
  state = {
    selectedTable: null
  }
  componentDidMount() {
    const {paperID} = this.props.match.params
    this.props.store.paperTrading.fetchPaperTrading(paperID)
    this.props.store.paperTrading.fetchMetrics(paperID)
    this.props.store.paperTrading.tables.toggleSelected('')
  }
  selectTable = (value) => {
    const {selectedTable} = this.state
    if (selectedTable === value) {
      this.setState({selectedTable: null})
      return
    }
    this.setState({selectedTable: value})
  }

  render() {
    const {paperTrading} = this.props.store
    const {start_date} = paperTrading.session
    const title = start_date ? 'Started on ' + timeFormat('%m-%d-%Y')(new Date(start_date)) : 'Paper trading'
    const {selectedTable} = this.state
    const {paperID} = this.props.match.params
    return(
      <div>
        <DocumentTitle title={title}/>
        <Header title={title}/>
        <Cards/>
        <div styleName='wrapper'>
          <div styleName='main'>
            {selectedTable === 'transactions' && <Transactions id={paperID}/>}
            {selectedTable === 'positions' && <Positions id={paperID}/>}
            <Charts id={paperID}/>
          </div>
        </div>
      </div>
    )
  }
}

export default PaperTrading
